import Article from "./Article";
import ArticleList from "./ArticleList";
import Home from "./Home";

const routes = [
  {
    key: "home",
    route: "/",
    component: <Home />,
  },
   {
    key: "article_list",
    route: "/:categoryId",
    component: <ArticleList />,
  },
   {
    key: "article",
    route: "/:categoryId/:articleId",
    component: <Article />,
  },
];

export default routes;
